import TBM from "../image/TBM.png";
import Keolis from "../image/Logo_Keolis_Bordeaux.jpg";

export const parisNetworks = [
  {
    id: "A",
    name: "Metro",
    slug: "metro",
    image: "http://restratpws.azurewebsites.net/api/images/p_met.gif",
  },
  {
    id: "B",
    name: "Bus",
    slug: "bus",
    image: "http://restratpws.azurewebsites.net/api/images/p_bus.gif",
  },
  {
    id: "C",
    name: "ReR",
    slug: "rer",
    image: "http://restratpws.azurewebsites.net/api/images/p_rer.gif",
  },
  {
    id: "D",
    name: "Tram",
    slug: "tram",
    image: "http://restratpws.azurewebsites.net/api/images/p_tram.gif",
  },
];

export const bordeauxNetworks = [
  {
    id: "A",
    name: "Tram",
    slug: "tram",
    image: TBM,
  },
  {
    id: "B",
    name: "Bus",
    slug: "bus",
    image: Keolis,
  },
];
